import { NB } from '@cerebral-inc/ui';
import { getStaticFilePath } from 'components/shared/utils';
import PurpleQuoteIcon from '../images/quotation-marks-purple.svg';
import FourStars from '../images/four-stars.svg';
import FiveStars from '../images/five-stars.svg';
import { IQuotesCarouselProps, Source } from './types';
import { Carousel, CarouselItem } from './Carousel';

const { Box, Text, Flex, Image } = NB;

export const QuotesCarousel = ({ quotes }: IQuotesCarouselProps) => {
  const getSource = (source?: Source) => {
    if (source === '4stars') {
      return FourStars;
    }

    if (source === '5stars') {
      return FiveStars;
    }

    return FiveStars;
  };

  return (
    <Box
      my={{ base: 0, md: '32px' }}
      mx={{ base: '24px', lg: 'auto' }}
      maxW={{ base: '100%', lg: '1216px' }}
    >
      <Carousel
        indicatorStyles={{
          desktop: { x: '0', y: '32%' },
          mobile: { x: '32px', y: '70%' }
        }}
        startingIndex={1}
      >
        {quotes.map(({ quote, name, source }) => (
          <CarouselItem key={quote}>
            <Flex
              alignItems="center"
              backgroundColor="#FFFFFF"
              textAlign="center"
              p={{ base: '40px', md: '32px' }}
              w={{ base: '100%', md: '85%' }}
              mb="24px"
              borderRadius="16px"
            >
              <Image
                src={getStaticFilePath(PurpleQuoteIcon)}
                alt=""
                w="38px"
                h="24px"
              />
              <Box>
                <Text
                  color="#353A41"
                  fontSize="18px"
                  lineHeight="24px"
                  my="16px"
                  textAlign="center"
                  fontFamily="Poppins"
                >
                  {quote}
                </Text>
              </Box>
              <Box>
                <Text
                  color="#1C1E21"
                  fontSize="16px"
                  fontWeight={600}
                  lineHeight="24px"
                  mb="16px"
                  textAlign="center"
                  fontFamily="Poppins"
                >
                  {name}
                </Text>
              </Box>
              <Image
                src={getStaticFilePath(getSource(source))}
                alt="stars"
                w="247px"
                h="17px"
              />
            </Flex>
          </CarouselItem>
        ))}
      </Carousel>
    </Box>
  );
};
